var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-kng-comment-audit-content standard-size-14",
    },
    [
      _c("div", { staticClass: "standard-size-16 yxt-weight-5" }, [
        _vm._v(_vm._s(_vm.$t("pc_biz_kng_lbl_commentdetail" /**评论详情 */))),
      ]),
      _c(
        "div",
        {
          staticClass:
            "yxtbiz-kng-comment-audit-content__line mt24 standard-size-14",
        },
        [
          _c(
            "span",
            {
              staticClass: "color-gray-7 flex-shrink-0",
              class: _vm.isEnglish ? "w98" : "w68",
            },
            [
              _vm._v(
                _vm._s(_vm.$t("pc_biz_kng_lbl_commentcontent" /**评论内容 */))
              ),
            ]
          ),
          _c("span", {
            staticClass: "yxtbiz-kng-comment-audit-content__text ml12",
            domProps: { innerHTML: _vm._s(_vm.info.content) },
          }),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "yxtbiz-kng-comment-audit-content__line mt24 standard-size-14",
        },
        [
          _c(
            "span",
            {
              staticClass: "color-gray-7 flex-shrink-0",
              class: _vm.isEnglish ? "w98" : "w68",
            },
            [
              _vm._v(
                _vm._s(_vm.$t("pc_biz_kng_lbl_commentname" /** 课程名称*/))
              ),
            ]
          ),
          _c(
            "yxt-tooltip",
            {
              staticClass: "ml12",
              attrs: { content: _vm.info.targetName, "open-filter": "" },
            },
            [
              _c("div", { staticClass: "ellipsis-1 color-primary-6 ml12" }, [
                _c(
                  "span",
                  { staticClass: "hand", on: { click: _vm.preview } },
                  [_vm._v(_vm._s(_vm.info.targetName))]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }